import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert, Box, Button, Card, CardContent, TextField, Typography, Link,
} from '@mui/material';
import { Science as ScienceIcon } from '@mui/icons-material';
import { apiPost } from '../../services/api';
import usePageTitle from '../../hooks/usePageTitle';

export default function ForgotPassword() {
  usePageTitle('Forgot Password');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    // The endpoint always succeeds (it never reveals whether the email exists).
    await apiPost('/api/Account/forgot-password', { email });
    setSubmitting(false);
    setSent(true);
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <Card sx={{ width: '100%', maxWidth: 420, mx: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <ScienceIcon sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
            <Typography variant="h5" fontWeight={700} color="primary.main">Reset your password</Typography>
          </Box>

          {sent ? (
            <Alert severity="success" sx={{ mb: 2 }}>
              If an account exists for that email, a reset link is on its way. Check your inbox.
            </Alert>
          ) : (
            <Box component="form" onSubmit={handleSubmit}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Enter your email and we'll send you a link to reset your password.
              </Typography>
              <TextField
                label="Email" type="email" fullWidth required autoFocus
                value={email} onChange={(e) => setEmail(e.target.value)}
                sx={{ mb: 3 }}
              />
              <Button type="submit" variant="contained" fullWidth size="large" disabled={submitting}>
                {submitting ? 'Sending...' : 'Send reset link'}
              </Button>
            </Box>
          )}

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            <Link component={RouterLink} to="/login">Back to sign in</Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
